import { Link } from 'react-router-dom'

import regeneration from '@/assets/images/services/regeneration.webp'
import { Button } from '@/components/button'
import { DefaultsEsgIcon } from '@/components/icons/services/defaults-esg'
import { EsgPanelsIcon } from '@/components/icons/services/regeneration/esg-panels'
import { PollinationIcon } from '@/components/icons/services/regeneration/pollination'
import { SatelliteTechnologyIcon } from '@/components/icons/services/satellite-technology'

import * as Card from '../../components/services-sections/card'
import * as Section from '../../components/services-sections/root'

export function RegenerationSection() {
  return (
    <section className="flex flex-col">
      <Section.ContainerRoot>
        <Section.Image src={regeneration} />
        <Section.Container>
          <Section.Title>Regeneração</Section.Title>
          <Section.Description>
            <Section.DescriptionBold>
              Transformamos áreas degradadas em ativos ambientais de alto valor
              por meio de soluções estratégicas para cada bioma brasileiro.
            </Section.DescriptionBold>{' '}
            Combinamos técnicas regenerativas, monitoramento por satélite
            multissensor, apicultura ecológica e rastreabilidade completa via
            blockchain. Cada projeto é mensurável e auditável para gerar
            créditos de carbono.
          </Section.Description>
        </Section.Container>
      </Section.ContainerRoot>

      <div className="flex flex-col gap-24">
        <Card.Scroll>
          {/* Card 1 */}
          <Card.Root>
            <Card.Container icon={SatelliteTechnologyIcon}>
              <Card.Description>
                Monitoramento de SAFs,{' '}
                <Card.DescriptionBold>
                  apicultura e agrofloresta
                </Card.DescriptionBold>{' '}
                via satélite
              </Card.Description>
            </Card.Container>
          </Card.Root>

          {/* Card 2 */}
          <Card.Root>
            <Card.Container icon={PollinationIcon}>
              <Card.Description>
                Índices exclusivos que correlacionam{' '}
                <Card.DescriptionBold>
                  polinização com produtividade
                </Card.DescriptionBold>
              </Card.Description>
            </Card.Container>
          </Card.Root>

          {/* Card 3 */}
          <Card.Root>
            <Card.Container icon={DefaultsEsgIcon}>
              <Card.Description>
                Validação científica para certificações premium e{' '}
                <Card.DescriptionBold>créditos de carbono</Card.DescriptionBold>
              </Card.Description>
            </Card.Container>
          </Card.Root>

          {/* Card 4 */}
          <Card.Root>
            <Card.Container icon={EsgPanelsIcon}>
              <Card.Description>
                Painéis ESG automatizados e auditáveis em{' '}
                <Card.DescriptionBold>blockchain</Card.DescriptionBold>
              </Card.Description>
            </Card.Container>
          </Card.Root>
        </Card.Scroll>
        <Button asChild className="mx-auto max-w-96 uppercase md:w-full">
          <Link to="/regeneration">Saiba mais</Link>
        </Button>
      </div>
    </section>
  )
}
